import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { api } from "../services/api";

export const SET_LOADING = "saga/SET_LOADING";
export const SET_SELECTED = "saga/SET_SELECTED";
export const SET_UPDATES_LOADING = "saga/SET_UPDATES_LOADING";
export const SET_ARCHIVES = "saga/SET_ARCHIVES";
export const SET_NOTIFICATIONS_LOADING = "saga/SET_NOTIFICATIONS_LOADING";

export const CHANGE_NOTIFICATION_LIST = "saga/CHANGE_NOTIFICATION_LIST";
export const UPDATE_NOTIFICATION_LIST_BY_ARCHIVED = "saga/UPDATE_NOTIFICATION_LIST_BY_ARCHIVED";

export const FETCH_NOTIFICATIONS_SUCCESS = "saga/FETCH_NOTIFICATIONS_SUCCESS";

export const ADD_NOTIFICATION = "saga/ADD_NOTIFICATION";
export const ADD_NOTIFICATION_SUCCESS = "saga/ADD_NOTIFICATION_SUCCESS";
export const ARCHIVE_NOTIFICATION = "saga/ARCHIVE_NOTIFICATION";

export const EDIT_NOTIFICATION = "saga/EDIT_NOTIFICATION";
export const EDIT_NOTIFICATION_SUCCESS = "saga/EDIT_NOTIFICATION_SUCCESS";

export const DELETE_NOTIFICATION = "saga/DELETE_NOTIFICATION";
export const DELETE_NOTIFICATION_SUCCESS = "saga/DELETE_NOTIFICATION_SUCCESS";

export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";

export const RESET_FILTERS = "saga/RESET_FILTERS";

const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  createNotification: createAction(ADD_NOTIFICATION),
  changeNotification: createAction(EDIT_NOTIFICATION),
  deleteNotification: createAction(DELETE_NOTIFICATION),
  setSelected: createAction(SET_SELECTED),
  changeArchives: createAction(CHANGE_NOTIFICATION_LIST),
  resetFilters: createAction(RESET_FILTERS),
  archiveNotification: createAction(ARCHIVE_NOTIFICATION)
};

export const {
  fetchCurrentUser,
  createNotification,
  changeNotification,
  deleteNotification,
  setSelected,
  changeArchives,
  updateFilters,
  resetFilters,
  archiveNotification
} = actionCreators;

export default function* watchNotifications() {
  yield takeLatestSafe(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatestSafe(ADD_NOTIFICATION, addNotification);
  yield takeLatestSafe(EDIT_NOTIFICATION, editNotification);
  yield takeLatestSafe(ARCHIVE_NOTIFICATION, archive);
  yield takeLatestSafe(DELETE_NOTIFICATION, removeNotification);
  yield takeLatestSafe(CHANGE_NOTIFICATION_LIST, changeNotificationList);
}

function takeLatestSafe(action, effect) {
  return takeLatest(action, tryCatch(effect));
}

function tryCatch(effect) {
  return function* (args) {
    try {
      yield call(effect, args);
    } catch (err) {
      console.error(err);
    }
  };
}

function* getCurrentUserData(data) {
  yield put({ type: SET_LOADING, payload: true });

  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: data.payload });

  yield fetchNotifications();
  yield put({ type: SET_LOADING, payload: false });
}

function* fetchNotifications() {
  const { archives } = yield getCommonApiParams();
  const { data } = yield call(api.getNotifications, { params: { archives } });

  yield put({
    type: FETCH_NOTIFICATIONS_SUCCESS,
    payload: data
  });
}

function* addNotification() {
  const { notification } = yield getCommonApiParams();

  const { data } = yield call(api.addNotification, { notification });

  yield put({
    type: ADD_NOTIFICATION_SUCCESS,
    payload: data
  });
}

function* changeNotificationList(action) {
  yield put({
    type: SET_ARCHIVES,
    payload: action.payload
  });
  yield put({
    type: SET_NOTIFICATIONS_LOADING,
    payload: true
  });

  yield call(fetchNotifications);

  yield put({
    type: SET_NOTIFICATIONS_LOADING,
    payload: false
  });
}

function* editNotification() {
  const { id, notification } = yield getCommonApiParams();
  yield saveEditedNotification(id, notification);
}

function* archive(info) {
  const { id, archived } = info.payload;
  yield saveEditedNotification(id, { archived });
}

function* saveEditedNotification(id, params) {
  const { data } = yield call(api.editNotification, id, params);

  yield put({
    type: UPDATE_NOTIFICATION_LIST_BY_ARCHIVED,
    payload: { id, archived: params.archived }
  });

  yield put({
    type: EDIT_NOTIFICATION_SUCCESS,
    payload: { id, notification: data }
  });
}

function* removeNotification() {
  const { id } = yield getCommonApiParams();

  yield call(api.removeNotification, id);

  yield put({
    type: DELETE_NOTIFICATION_SUCCESS,
    payload: id
  });
}

function* getCommonApiParams() {
  return yield select((state) => {
    const {
      archives,
      selected: {
        notificationId: id,
        all_organizations,
        organization_ids,
        published,
        archived,
        message,
        title,
        start_on,
        end_on
      }
    } = state.notifications;

    return {
      id,
      notification: {
        publish_to_all_orgs: all_organizations.toString(),
        published: published.toString(),
        archived,
        organization_ids: organization_ids.join(","),
        message: message.trim(),
        title: title.trim(),
        start_on,
        end_on
      },
      archives
    };
  });
}
